import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from './shared/shared.service';
import { GDPRManager } from './managers/gdpr.manager';
import { environment } from './../environments/environment';
import { productLinks } from './app.const';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  version: string;
  productLinks = productLinks;
  constructor(private sharedService: SharedService, private mgr: GDPRManager, public router: Router) {
    this.version = environment.version;
  }
  updateNavBar(item) {
    this.sharedService.showNavBar = false;
    const params = this.mgr.getParams();
    if (item['name'] === 'Opt out') {
      this.router.navigate([item.url],
        {
          queryParams: params
        });
    } else {
      if (item && item['url']) {
        if (item['params']) {
          params['target'] = item['params'];
        }
        this.router.navigate([item.url],
          {
            queryParams: params
          });
      }
    }
  }
  showNavBar() {
    event.stopPropagation();
    this.sharedService.showNavBar = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts